<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3>套餐名称:</h3>
          <h3 class="tcName">{{ item.pk_name }}</h3>
        </div>
        <van-grid class="content" :column-num="3" :gutter="10">
          <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V1</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase1 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle1 }}</p> </li>
            </ul>
          </van-grid-item>
          <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V2</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase2 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle2 }}</p> </li>
            </ul>
          </van-grid-item>
          <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V3</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase3 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle3 }}</p> </li>
            </ul>
          </van-grid-item>
          <!-- <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V4</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase4 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle4 }}</p> </li>
            </ul>
          </van-grid-item>
          <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V5</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase5 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle5 }}</p> </li>
            </ul>
          </van-grid-item> -->
          <!-- <van-grid-item>
            <ul>
              <li> <h3>等级</h3> <p class="gradeNum">V6</p> </li>
              <li> <h3>采购价</h3> <p>￥{{ item.purchase6 }}</p> </li>
              <li> <h3>结算价</h3> <p>￥{{ item.settle6 }}</p> </li>
            </ul>
          </van-grid-item> -->
        </van-grid>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 500px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    padding: 40px 10px 20px;
    .title {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin: 0 30px;
        h3 {
          font-size: 28px;
          color: #272729;
          font-weight: 700;
        }
        .tcName {
          font-size: 28px;
          color: #1b60ce;
        }
      }
      .content {
        flex: 8;
        margin-top: 15px;
        /deep/.van-grid-item {
          .van-grid-item__content{
            background-color: #ECF2F9;
            border-radius: 15px;
            padding: 20px 15px;
            font-size: 20px;
            ul {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              color: #fff;
              li {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                color: #6F6F76;
                p {
                  font-size: 25px;
                }
                h3 {
                  font-weight: 400;
                }
                .gradeNum {
                  color: #4c59f6;
                  font-size: 30px!important;
                }
              }
              li:first-child {
                align-items: center;
              }
            }
          }
        }
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-3.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
  }
</style>
